export const globalAggregationModels = [
  'Count',
  'DeviationFromAverage',
  'RelativeSize',
  'TotalAverage',
];
